import { useTranslation } from '@ecomm/i18n'
import { ComparisonTableV2 } from '../ComparisonTableV2'
import { Footer } from './Footer'
import { RowActiveGuard } from './RowActiveGuard'
import { RowAntiTheft } from './RowAntiTheft'
import { RowAppControlBusiness } from './RowAppControlBusiness'
import { RowCamera } from './RowCamera'
import { RowElevatedSupportBusiness } from './RowElevatedSupportBusiness'
import { RowHardware } from './RowHardware'
import { RowIntruder } from './RowIntruder'
import { RowMonitoring } from './RowMonitoring'
import { RowNoContracts } from './RowNoContracts'
import { RowUniquePins } from './RowUniquePins'
import { RowUnlimitedRecordings } from './RowUnlimitedRecordings'
import { RowVideoVerification } from './RowVideoVerification'
import { StandardPlanBoxAndModal } from './StandardPlanBoxAndModal'

export function USBusinessComparisonTable() {
  const { t } = useTranslation('maps')

  return (
    <div>
      <ComparisonTableV2
        caption={t('microtext.comparison-table-title')}
        rowLabels={[
          t('plan-name.core-business'),
          t('plan-name.pro-business'),
          t('plan-name.pro-plus-business')
        ]}
      >
        <RowMonitoring />
        <RowCamera />
        <RowActiveGuard />
        <RowIntruder />
        <RowVideoVerification />
        <RowUnlimitedRecordings />
        <RowUniquePins />
        <RowAppControlBusiness />
        <RowHardware />
        <RowAntiTheft />
        <RowNoContracts />
        <RowElevatedSupportBusiness />
        <Footer />
      </ComparisonTableV2>
      <StandardPlanBoxAndModal />
    </div>
  )
}
